import { styled } from '@mui/material';
import { ReactComponent as IconGlass } from '../../../assets/images/glass.svg';

export const StyledIconGlass = styled(IconGlass)(() => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
}));
